import React, { useState } from 'react';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Textarea } from '../ui/textarea';
import { CLOSURE_REASONS, INQUIRY_STATUSES } from '../../pages/inquiries/constants';

const closingStatuses = ['lost', 'closed'];

export const InquiryStatusControl = ({ currentStatus, onUpdate, saving }) => {
  const [status, setStatus] = useState(currentStatus || 'new');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [notes, setNotes] = useState('');

  const chooseStatus = (value) => {
    setStatus(value);
    if (closingStatuses.includes(value)) setDialogOpen(true);
    else onUpdate({ status: value });
  };

  const closeInquiry = () => {
    onUpdate({ status, closure_reason: reason, closure_notes: notes });
    setDialogOpen(false);
  };

  return (
    <>
      <Select value={status} onValueChange={chooseStatus} disabled={saving}>
        <SelectTrigger className="w-[210px]" data-testid="inquiry-status-select"><SelectValue /></SelectTrigger>
        <SelectContent>{INQUIRY_STATUSES.map((item) => <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>)}</SelectContent>
      </Select>
      <Dialog open={dialogOpen} onOpenChange={(open) => { setDialogOpen(open); if (!open) setStatus(currentStatus); }}>
        <DialogContent data-testid="inquiry-closure-dialog">
          <DialogHeader><DialogTitle>Close this inquiry</DialogTitle>
            <DialogDescription>A closure reason is required for retained commercial history.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-3">
            <div className="space-y-2"><Label>Closure reason *</Label>
              <Select value={reason} onValueChange={setReason}>
                <SelectTrigger data-testid="inquiry-closure-reason-select"><SelectValue placeholder="Select reason" /></SelectTrigger>
                <SelectContent>{CLOSURE_REASONS.map((item) => <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div className="space-y-2"><Label>Notes {reason === 'other' ? '*' : ''}</Label>
              <Textarea value={notes} onChange={(event) => setNotes(event.target.value)} data-testid="inquiry-closure-notes-input" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setDialogOpen(false)} data-testid="inquiry-closure-cancel-button">Cancel</Button>
            <Button onClick={closeInquiry} disabled={!reason || (reason === 'other' && !notes.trim()) || saving} data-testid="inquiry-closure-confirm-button">
              {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <CheckCircle2 className="mr-2 h-4 w-4" />} Confirm closure
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};